// extracted by mini-css-extract-plugin
module.exports = {"main":"PaymentBtn_main__bfM59"};